__turbopack_context__.v({
  "closeButton": "snayLW_closeButton",
  "fadeIn": "snayLW_fadeIn",
  "modalContainer": "snayLW_modalContainer",
  "modalContent": "snayLW_modalContent",
  "modalOverlay": "snayLW_modalOverlay",
  "slideUp": "snayLW_slideUp",
});
